var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgoraLogo = function SvgAgoraLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 16C32.0003 24.8366 24.8371 32 16.0018 32C7.16215 32 -0.000488281 24.8366 -0.000488281 16C-0.000488281 7.16315 7.16215 0 16.0018 0C16.1797 0 16.3571 0.00719833 16.5357 0.0131111C15.0415 0.907669 13.7096 2.05209 12.5778 3.40781L15.9957 6.82255C18.149 4.23579 21.2679 2.67237 25.0011 2.77185C29.2264 5.65269 32.0003 10.5023 32.0003 16Z",
    fill: "#EE1E44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5781 3.40778L15.996 6.82227C18.1493 4.23576 21.2679 2.67234 25.0012 2.77182C22.5746 1.11766 19.6693 0.116417 16.535 0.0135942C15.0418 0.907382 13.7094 2.05206 12.5781 3.40778Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9512 9.50009L5.06177 20.3906L8.24028 23.5693L15.953 15.8558L23.6655 23.5693L26.8438 20.3926L15.9512 9.50009Z",
    fill: "#ffffff"
  })));
};
export default SvgAgoraLogo;